export default __webpack_public_path__ + "static/media/baked.5077e324.png";